module.exports = __webpack_public_path__ + "img/trianglecube.02fa8f61.jpg";